import { create } from 'zustand';

const getQuickAnswersSlice = (state) => ({
  showQuickAnswers: state.showQuickAnswers,
  messageIdToQuickAnswer: state.messageIdToQuickAnswer,
  isAddingNewAnswer: state.isAddingNewAnswer,
  openClearAllQuickAnswers: state.openClearAllQuickAnswers,
  openClearSelectedQuickAnswer: state.openClearSelectedQuickAnswer,
  selectedQuickAnswerToClear: state.selectedQuickAnswerToClear,
  messagesWithMediaUrl: state.messagesWithMediaUrl,
  quickAnswersData: state.quickAnswersData,
});

export const useQuickAnswersStore = create((set) => ({
  showQuickAnswers: false,
  messageIdToQuickAnswer: '',
  isAddingNewAnswer: false,
  openClearAllQuickAnswers: false,
  openClearSelectedQuickAnswer: false,
  selectedQuickAnswerToClear: {},
  messagesWithMediaUrl: [],
  quickAnswersData: [],

  // Simple setters
  setQuickAnswers: (quickAnswersOrFn) => set((state) => {
    const currentQuickAnswers = getQuickAnswersSlice(state);
    const nextQuickAnswers = typeof quickAnswersOrFn === 'function'
      ? quickAnswersOrFn(currentQuickAnswers)
      : quickAnswersOrFn;

    return nextQuickAnswers;
  }),
  setShowQuickAnswers: (show) => set({ showQuickAnswers: show }),
  setMessageIdToQuickAnswer: (messageId) => set({ messageIdToQuickAnswer: messageId }),
  setIsAddingNewAnswer: (isAdding) => set({ isAddingNewAnswer: isAdding }),
  setOpenClearAllQuickAnswers: (open) => set({ openClearAllQuickAnswers: open }),
  setOpenClearSelectedQuickAnswer: (open) => set({ openClearSelectedQuickAnswer: open }),
  setSelectedQuickAnswerToClear: (quickAnswer) => set({
    selectedQuickAnswerToClear: quickAnswer,
  }),
  setMessagesWithMediaUrl: (msgsOrFn) => set((state) => ({
    messagesWithMediaUrl: typeof msgsOrFn === 'function'
      ? msgsOrFn(state.messagesWithMediaUrl)
      : msgsOrFn,
  })),
  setQuickAnswersData: (data) => set({ quickAnswersData: data }),

  // Composed actions
  openQuickAnswers: (messageId) => set({
    showQuickAnswers: true,
    messageIdToQuickAnswer: messageId,
  }),

  closeQuickAnswers: () => set({
    showQuickAnswers: false,
    messageIdToQuickAnswer: '',
    isAddingNewAnswer: false,
  }),

  openClearConfirmation: (quickAnswer) => set({
    openClearSelectedQuickAnswer: true,
    selectedQuickAnswerToClear: quickAnswer,
  }),

  closeClearConfirmation: () => set({
    openClearSelectedQuickAnswer: false,
    selectedQuickAnswerToClear: {},
  }),
}));
